// FolderSearchContext.js
import { createContext, useContext, useState } from "react";

const FolderSearchContext = createContext();

export const FolderSearchProvider = ({ children }) => {
  const [requestFilter, setRequestFilter] = useState([]);
  const [irisFilter, setIrisFilter] = useState(null);

  return (
    <FolderSearchContext.Provider
      value={{ requestFilter, setRequestFilter, irisFilter, setIrisFilter }}
    >
      {children}
    </FolderSearchContext.Provider>
  );
};

export const useFilterSearchContext = () => useContext(FolderSearchContext);
